import { Text } from '_/components';
import { colors } from '_/constants/theme';
import { useSlotContext } from '_/hooks/SlotContext';
import { useSpaceContext } from '_/hooks/SpaceContext';
import { SlotsModel } from '_/services/models/slots.model';
import React, { useCallback } from 'react';
import { TouchableOpacity } from 'react-native';

import styles from './styles';

export interface SlotProps {
  slot: Omit<SlotsModel, 'amenities'>;
  handleSelectSlot?: (slot: SlotsModel) => void;
}

export default function Slot({ slot, handleSelectSlot }: SlotProps) {
  const { setIsSlotModalVisible } = useSlotContext();
  const { spaceType } = useSpaceContext();

  const handlePress = useCallback(() => {
    if (handleSelectSlot) return handleSelectSlot(slot as SlotsModel);

    setIsSlotModalVisible(slot.id);
  }, [handleSelectSlot, setIsSlotModalVisible, slot]);

  return (
    <>
      <TouchableOpacity style={styles(spaceType).slot} onPress={handlePress}>
        <Text
          fontSize={18}
          color={colors.black}
          fontType="medium"
          style={styles().slotName}
          numberOfLines={3}
        >
          {slot.name}
        </Text>
      </TouchableOpacity>
    </>
  );
}
